import { ethers } from "ethers";
import { atom, selector } from "recoil";

export const currentMetamaskAddress = atom<string | null>({
  key: "currentMetamaskAddress",
  default: null,
});

export const isMetamaskConnected = selector({
  key: "isMetamaskConnected",
  get: ({ get }) => {
    const currentAddress = get(currentMetamaskAddress);
    return currentAddress && ethers.utils.isAddress(currentAddress);
  },
});
